import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import ScrollToTop from "./components/ScrollToTop";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import LocationPage from "./pages/LocationPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={
            <>
              <Header />
              <main><HomePage /></main>
              <Footer />
              <WhatsAppButton />
            </>
          } />
          <Route path="/services" element={
            <>
              <Header />
              <main><ServicesPage /></main>
              <Footer />
              <WhatsAppButton />
            </>
          } />
          <Route path="/location" element={
            <>
              <Header />
              <main><LocationPage /></main>
              <Footer />
              <WhatsAppButton />
            </>
          } />
          <Route path="/privacy-policy" element={
            <>
              <Header />
              <main><PrivacyPolicyPage /></main>
              <Footer />
              <WhatsAppButton />
            </>
          } />
          <Route path="/terms-of-service" element={
            <>
              <Header />
              <main><TermsOfServicePage /></main>
              <Footer />
              <WhatsAppButton />
            </>
          } />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
